// Modal de confirmacion para auto-aprobacion (Δ3).
// Recuerda explicitamente que el caso "1 nutricionista activa" deja registro
// en audit. Pide justificacion >=10 chars (espejo backend AutoAprobarBody).
import { useEffect, useState } from 'react'
import { ModalShell } from '../ui/ModalShell'

interface ConfirmarAutoAprobacionProps {
  entidadLabel: string // p.ej. "Ingrediente HARINA_FORT"
  onConfirm: (justificacion: string) => Promise<void> | void
  onCancel: () => void
}

const MIN_JUSTIFICACION = 10

export default function ConfirmarAutoAprobacion({
  entidadLabel,
  onConfirm,
  onCancel,
}: ConfirmarAutoAprobacionProps) {
  const [justif, setJustif] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape' && !submitting) onCancel()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onCancel, submitting])

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    const j = justif.trim()
    if (j.length < MIN_JUSTIFICACION) {
      setError(`La justificacion debe tener al menos ${MIN_JUSTIFICACION} caracteres`)
      return
    }
    setSubmitting(true)
    try {
      await onConfirm(j)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al auto-aprobar')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <ModalShell
      title="Confirmar auto-aprobacion"
      subtitle={entidadLabel}
      onClose={onCancel}
      closeDisabled={submitting}
      maxWidth={440}
    >
        <div
          role="note"
          className="text-sm bg-yellow-50 border border-yellow-300 text-yellow-900 rounded p-3 mb-3"
        >
          <strong>Solo 1 nutricionista activa</strong> — auto-aprobacion quedara
          en audit para el reporte mensual a admin (Δ3).
        </div>

        <form onSubmit={handleSubmit} className="space-y-3">
          <label className="block">
            <span className="text-sm font-semibold">
              Justificacion (mínimo {MIN_JUSTIFICACION} caracteres)
            </span>
            <textarea
              value={justif}
              onChange={(e) => setJustif(e.target.value)}
              maxLength={500}
              rows={4}
              required
              minLength={MIN_JUSTIFICACION}
              aria-label="Justificacion auto-aprobacion"
              placeholder="Ej: Ingrediente estandar INCAP, sin variacion respecto a la version anterior."
              className="mt-1 w-full border rounded px-2 py-1 text-sm"
            />
            <span className="block text-xs text-gray-500 mt-1">
              {justif.trim().length}/500
            </span>
          </label>

          {error && (
            <p role="alert" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded p-2">
              {error}
            </p>
          )}

          <div className="flex gap-2 pt-2">
            <button
              type="button"
              onClick={onCancel}
              disabled={submitting}
              className="flex-1 border py-2 rounded text-sm disabled:opacity-50"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="flex-1 bg-yellow-600 text-white py-2 rounded text-sm font-semibold disabled:opacity-50"
            >
              {submitting ? 'Procesando…' : 'Confirmar auto-aprobacion'}
            </button>
          </div>
        </form>
    </ModalShell>
  )
}
